// Реплика с большими вставками (как в Claude Code): в логе видны токены
// `[Pasted text #N +K lines]`, агент получил полный текст. Клик по токену
// разворачивает вставку под репликой — посмотреть, что именно ушло.

import { Fragment, memo, useState } from 'react'
import type { ReactNode } from 'react'
import type { PastedText } from '../../protocol'
import { inline } from '../inline'
import { PASTE_TOKEN } from './commands'

function PasteText({ text, pastes, keyPrefix }: { text: string; pastes: PastedText[]; keyPrefix: string }) {
  const [open, setOpen] = useState<number[]>([])
  const byId = new Map(pastes.map((p) => [p.id, p.text]))
  const parts: ReactNode[] = []
  let last = 0
  let i = 0
  for (const m of text.matchAll(PASTE_TOKEN)) {
    const start = m.index ?? 0
    const id = Number(m[1])
    if (start > last) parts.push(<Fragment key={`t${i}`}>{inline(text.slice(last, start), `${keyPrefix}-${i}`)}</Fragment>)
    if (byId.has(id)) {
      const on = open.includes(id)
      parts.push(
        <button
          type="button"
          key={`p${i}`}
          className={`cli-paste${on ? ' is-on' : ''}`}
          title={on ? 'свернуть вставку' : 'показать вставку'}
          onClick={() => setOpen((cur) => (on ? cur.filter((x) => x !== id) : [...cur, id]))}
        >
          {m[0]}
        </button>,
      )
    } else {
      parts.push(<Fragment key={`p${i}`}>{m[0]}</Fragment>)
    }
    last = start + m[0].length
    i += 1
  }
  if (last < text.length) parts.push(<Fragment key="tail">{inline(text.slice(last), `${keyPrefix}-tail`)}</Fragment>)
  return (
    <>
      {parts}
      {open.map((id) => (
        <pre key={`o${id}`} className="cli-paste__body">{byId.get(id)}</pre>
      ))}
    </>
  )
}

export default memo(PasteText)
